<template>
  <div>
    <Breadcrumbs main="" title="firebase email"/>
      <!-- Container-fluid starts-->
      <div class="container-fluid">
        <div class="row">

          <div class="col-xl-12">
            <div class="card">
              <div class="card-header firebase-header">
                <h5>Email List (Firebase)</h5>
              </div>

              <div class="card-body custom-scrollbar">
                <div class="todo">
                  <div class="todo-list-wrapper">
                    <div class="todo-list-container">
                      <div class="table-responsive datatable-vue m-0 vue-smart">                                      
                        <v-table
                            :data="emailList" class="table"
                            :currentPage.sync="basic.currentPage"
                            :pageSize="10"
                            @totalPagesChanged="basic.totalPages = $event"
                        >
                          <thead slot="head">
                            <th>From(Id/Name)</th>
                            <th>To</th>
                            <th>Items</th>
                            <th>Contents</th>
                            <v-th sortKey="deadline">Deadline</v-th>        
                            <th>Checked</th>
                            <th>Status</th>
                            <th>Del</th>
                          </thead>
                          <tbody slot="body" slot-scope="{displayData}">
                            <tr v-for="(todo, index) in displayData" :key="index" class="task" :class="{'completed':todo.status == 'complete'}">
                              <td>
                                <b-badge pill variant="success">{{ todo.senderUid }}</b-badge><br>{{ todo.senderName }}
                              </td>
                              <td>
                                <b-badge pill variant="success">{{ todo.receiverUid }}</b-badge>
                              </td>                                                            
                              <td>
                                <div v-for="(itemId, name) in itemlist" :key="name">
                                  <div v-if="itemId.itemId==todo.item.id">
                                    <b-badge pill variant="info"> {{ itemId.name }}<i class="icofont icofont-error"></i> {{ todo.item.count }}</b-badge> 
                                  </div>
                                </div>                                
                              </td>
                              <td>
                                <div><b-badge pill variant="success">Title : </b-badge>{{ todo.title }}</div>
                                <div><b-badge pill variant="success">Message : </b-badge>{{ todo.message }}</div>
                              </td>
                              <td><b-badge pill variant="success">{{ formatDate(todo.deadline) }}</b-badge></td>
                              <td class="text-center">
                                <div v-if ="todo.checked == null"><i class="icofont icofont-error"></i></div>
                                <div v-else pill variant="success"><b-badge pill variant="success">{{ formatDateChecked(todo.checked) }}</b-badge></div>                                
                              </td>
                              <td>
                                <span @click="taskActive(todo.id,todo.status)" class="action-box large complete-btn" title="Mark Complete">
                                  <b-badge v-if="todo.status=='INACTIVE'" pill variant="secondary"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                                  <b-badge v-else pill variant="success"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                                </span>  
                              </td>
                              <td>
                                <span class="task-action-btn">
                                  <span @click="tododelete(todo.id)" class="action-box large delete-btn" title="Delete Task"><i class="icon"><i class="icon-trash"></i></i></span>
                                </span>                            
                              </td>
                            </tr>
                          </tbody>
                        </v-table>      

                        <smart-pagination
                            :currentPage.sync="basic.currentPage"
                            :totalPages="basic.totalPages"
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <notifications classes="task" group="emailList" />
                  </div>
                </div>
              </div>
            </div>                
          </div>

        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-primary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionWrite><i class="fa fa-pencil-square"></i> Write Email<span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionWrite" accordion="my-accordion" role="tabpanel">
                <b-card-body>

                <div class="row">

                  <div class="col-sm-12">
                    <div class="form-row">  
                      <div class="col-md-3 mb-3">
                        <b-input-group prepend="Sender ID">                          
                          <b-form-input v-model="email_senderUid" type="text" placeholder="" id="email_senderUid" name="email_senderUid" ></b-form-input>
                        </b-input-group>
                      </div>            
                      <div class="col-md-9 mb-3">
                        <b-input-group prepend="Sender Name">
                          <b-form-input v-model="email_senderName" type="text" placeholder="" id="email_senderName" name="email_senderName"></b-form-input>
                        </b-input-group>
                      </div>                                          
                    </div>

                    <div class="form-row">  
                      <div class="col-md-12 mb-3">
                        <b-input-group prepend="Receiver Id">
                          <b-form-input v-model="email_receiverUid" type="text" placeholder="" id="email_receiverUid" name="email_receiverUid"></b-form-input>
                        </b-input-group>                        
                      </div>                                          
                    </div> 

                    
                    <div class="form-row">
                      <div class="col-md-3 mb-3">
                        <b-input-group prepend="Item ID">
                          <b-form-select v-model="email_itemId" id="email_itemId" name="email_itemId">
                            <option v-for="(todo, index) in itemlist" v-bind:key="index" :value="todo.itemId">{{todo.name}}</option>
                          </b-form-select>                                          
                        </b-input-group>                                                                      
                      </div>
                      <div class="col-md-3 mb-3">
                        <b-input-group prepend="Item Count">
                          <b-form-input v-model="email_itemCount" type="number" placeholder="0" id="email_itemCount" name="email_itemCount"></b-form-input>
                        </b-input-group>                                          
                      </div>  
                      <div class="col-md-3 mb-3">
                        <b-input-group prepend="Deadline">
                          <datepicker v-model="email_deadline" input-class="datepicker-here form-control digits" :format="format" id="email_deadline" name="email_deadline"></datepicker>                              
                        </b-input-group>                                          
                      </div>  
                      <div class="col-md-3 mb-3">
                        <div class="media">
                          <label class="col-form-label m-r-10">Send Push Notification</label>
                          <div class="media-body text-right">
                            <label class="switch">
                              <input v-model="email_sendPush" id="email_sendPush" name="email_sendPush" type="checkbox" checked=""><span class="switch-state"></span>
                            </label>
                          </div>
                        </div>    
                      </div>                      
                    </div>                    
                  </div>

                  
                  
                  <!-- Description -->
                  <div class="col-sm-12">
                    <div class="form-group mb-3">
                      <b-input-group prepend="Title">
                        <b-form-input v-model="email_title" id="email_title" name="email_title" placeholder=""></b-form-input>
                      </b-input-group>

                    </div>  
                    <div class="form-group mb-3">                            
                      <b-input-group prepend="Message">
                        <b-form-textarea v-model="email_message" id="email_message" name="email_message" placeholder="" rows=5></b-form-textarea>
                      </b-input-group>
                    </div>     

                  </div>    
                </div>
                <span @click="addnewtask()" class="btn btn-success ml-0 add-new-task-btn" id="add-task">Send</span>

                </b-card-body>
              </b-collapse>
            </b-card>                                                                    
          </div>
        </div>        

        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-secondary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionHowto><i class="fa fa-question-circle"></i> Howto <span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionHowto" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  1. Sender Id는 주로 Game Master의 ID가 입력됩니다. 편집은 불가능합니다.<br>
                  2. Sender Name은 Player에게 보여질 발신자의 이름입니다.<br>
                  3. Receiver Id는 필수적으로 입력해야 합니다.<br>
                  4. Deadline은 'yyyy-mm-dd HH:mm:ss' 형식으로 기한을 입력해주세요.
                </b-card-body>
              </b-collapse>
            </b-card>                                                                    
          </div>
        </div>  

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import items from '../../data/items';
  import Datepicker from 'vuejs-datepicker';
  import VueSlideBar from 'vue-slide-bar';
  import moment from 'moment'
  

  export default{
    name:'todo',
    data(){
      return{
        format: "yyyy/MM/dd",
        email_itemCount:1,

        items,

        basic:{
          currentPage: 1,
          totalPages: 0,
        },

        filter:{
          currentPage: 1,
          totalPages: 0,
        },

        idfilter:{
          currentPage: 1,
          totalPages: 0,
        },

        selectrow:{
          currentPage: 1,
          totalPages: 0,
        },

        filters: {
            senderUid: { value: '', keys: ['senderUid'] },
            senderName: { value: '', keys: ['senderName'] },
            receiverUid: { value: '', keys: ['receiverUid'] },
            item: { value: '', keys: ['item'] },
            deadline: { value: '', keys: ['deadline'] },
            title: { value: '', keys: ['title'] },
            message: { value: '', keys: ['message'] },
            created: { value: '', keys: ['created'] },
            checked: { value: '', keys: ['checked'] },
            status: { value: '', keys: ['status'] }
        },

        giftTypeOptions:[
            { value:'ALL', text: 'ALL(모두에게)', selected: true }
        ],

        giftMarketOptions:[
            { value:'ALL', text: 'All(모든 마켓)', selected: true },
            { value:'GOOGLE', text: 'Google Play'},
            { value:'ITUNES', text: 'iTunes'},
            { value:'ONESTORE', text: 'OneStore'},
            { value:'SAMSUNG', text: 'Samsung'},
            { value:'KDDI', text: 'KDDI'}
        ],

        giftItemOptions:[
            { value:['itemId'], text:['name']}
        ],
        email_itemId : 1,
        email_sendPush : false
      }
    },
    components: {
      Datepicker,
      VueSlideBar
    },
    computed: {
      ...mapState({
        itemlist: state => state.firebase_item.todo,
        emailList: state => state.firebase_email.todo,
      }),
      formatted(){
        return Vue.filter('todo.checked')(this.value)
      }      
      
    },
    created(){
      this.$store.dispatch('firebase_item/retrieveTodos')
      this.retrieveTodos();
    },
    

    methods:{
      getImgUrl(filename) {
        var images = require.context('../../assets/images/job-search/', false, /\.jpg$/)
        return images('./' + filename)
      },      
       // methods area
      formatDate: function(dt){
        return moment(dt).fromNow();//format('YYYY-MM-DD hh:mm');
      },
      formatDateChecked: function(dt){
        //this.$toasted.show("Gift "+dt.toDate()+" as ACTIVE.", {theme: 'outline', type: 'success', duration: 2000});
        return moment(String(dt.toDate())).format('YYYY-MM-DD hh:mm')
      },

      retrieveTodos()
      {        
        this.$store.dispatch('firebase_email/retrieveTodos')
      },

      taskActive(id, status)
      {
        this.$store.dispatch('firebase_email/taskActive', id)
        this.retrieveTodos();

        if(status != "INACTIVE")
          this.$toasted.show("Gift marked as ACTIVE.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Gift marked as INACTIVE.", {theme: 'outline', type: 'error', duration: 2000});
      },

      tododelete(id)
      {
        this.$store.dispatch('firebase_email/tododelete', id)
        this.retrieveTodos();
        this.$toasted.show("Task has been deleted.",{theme:'outline', type : 'success',duration:2000});
      },

      addnewtask()
      {
        if(this.email_receiverUid == null)
        {
          this.$toasted.show("Must insert receiver Id", {theme: 'outline', type: 'success', duration: 2000});
        }
        else if(this.email_message == null)
        {
          this.$toasted.show("Must insert any message", {theme: 'outline', type: 'success', duration: 2000});
        }
        else
        {
          this.$store.dispatch('firebase_email/addtodo', this)
          
          //this.email_itemCount = 0
          //this.email_message = ""
          /*
          var container = this.$el.querySelector(".todo-list-body");
          setTimeout(function () 
          {
            container.scrollBy({ top: 200, behavior: 'smooth' });
          }, 310)
          */

          this.$toasted.show("New mail has sent.",{theme:'outline', type : 'success',duration:2000});
          this.retrieveTodos();
        }
      }
    }
  }
</script>
